import { mapGetters } from 'vuex'

export default {
  props: ['page'],
  data () {
    return {

    }
  },
  mounted () {
    // The swiper that we use for the scrubber needs to know the size of each item for correct initialization.

    // get the height of the first item
    let itemHeight = document.getElementsByClassName('swiper-lazy')[0].offsetHeight

    // Get the height and the accumilated width for first and second page
    let pageObjHeight = parseFloat(this.page.firstPage.attributes.ObjectHeight)
    let pagesObjWidth = parseFloat(this.page.firstPage.attributes.ObjectWidth)
    if (this.page.secondPage !== null) {
      pagesObjWidth += parseFloat(this.page.secondPage.attributes.ObjectWidth)
    }

    // calculate width for first and second page in px.
    let heightFactor = itemHeight / pageObjHeight
    let itemWidth = pagesObjWidth * heightFactor

    // set width
    document.getElementById(this._uid + '-scrubber-figure').style.width = itemWidth + 'px'

    this.applySettings(this.settings)
  },
  computed: {
    firstImage: function () {
      if (this.page !== undefined && this.showScrubber) {
        return this.getImageReference(this.page.firstPage)
      }
      return null
    },
    lastImage: function () {
      if (this.page !== undefined && this.showScrubber) {
        if (this.page.secondPage !== null) {
          return this.getImageReference(this.page.secondPage)
        }
      }
      return null
    },
    pageNumber: function () {
      if (this.page !== undefined) {
        var firstNumber = this.page.firstPage.pageNumber
        if (this.page.secondPage !== null) {
          let secondNumber = this.page.secondPage.pageNumber
          return firstNumber + '-' + secondNumber
        }
        return firstNumber
      }
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      settings: 'getSettings',
      showScrubber: 'getShowScrubber'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var scrubberElem = document.getElementsByClassName('scrubber-figure')
        for (var i = 0; i < scrubberElem.length; i++) {
          scrubberElem[i].style.borderColor = settings.scrubberPageFramesColor
        }

        var pageNumberElem = document.getElementsByClassName('scrubber-page-number')
        for (var j = 0; j < pageNumberElem.length; j++) {
          pageNumberElem[j].style.color = settings.scrubberNumbersColor
        }
      }
    },
    getImageReference (page) {
      return this.getEncodedResourceUrl(page.thumbnail, page.attributes.LastRev)
    },
    goToPage() {
      this.$store.commit('setCurrentPage', this.page)
      this.$store.commit('toggleScrubberVisible')
    }
  }
}
